import {createSlice} from '@reduxjs/toolkit';
import {FormProductInit} from "./model";
const R = require('ramda');

const initialState = {
    products: [],
    productForm: FormProductInit,
    attributes: {},
    productTypes: []

};

const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        setProduct: (state, action) => {
            state.products = action.payload;
        },
        setProductForm: (state, action) => {
            state.productForm = action.payload
        },
        setProductAttributes: (state, action) => {
            state.attributes = action.payload
        },

        initProductForm: (state, action) => {
            state.productForm = FormProductInit;
        },
        onProductFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.productForm[name] = value;
        },
        onProductFormAttributeChange: (state, action) => {
            const {name, value} = action.payload;
            // const hasBrownHair = R.propEq('name', name);
            // let index = R.findIndex(R.propEq('name', name))(state.attributes) //=> [fred, rusty]
            // const index = state.productForm.attributes.findIndex(item => item.name === name);
            state.attributes[name] = value;
        },
        setProductTypes: (state, action) => {
            state.productTypes = action.payload
        }
    },
});

export const {actions} = productSlice;
export const {
    setProduct,
    setProductForm,
    initProductForm,
    onProductFormChange,
    onProductFormAttributeChange,
    setProductTypes,
    setProductAttributes
} = actions;

// reducers

// selectors
export const selProduct = (state) => state.product.products;
export const selProductForm = (state) => state.product.productForm;
export const selProductTypes = (state) => state.product.productTypes;
export const selProductAttributes = (state) => state.product.attributes;

const productReducer = {
    product: productSlice.reducer,
};
export default productReducer;
